import { __decorate } from "tslib";
import { injectable } from '@/inversify.config';
import { DEPLOY_ENV, CLIENT_ID, CLIENT_NAME, NODE_ENV, PACKAGE_VERSION, WSPLUGIN_ENTRY_BIO, WSPLUGIN_ENTRY_SYNAPSE, OFFICIAL_URL, STATIC_COMMON_URL, LAB_PATENT_COLOR_ANCHOR, LAB_DEEP_VIEW_ANCHOR, LAB_HI_RES_IMAGE_ANCHOR, PASSPORT_URI, ACCOUNT_SERVICE_URI, ACCOUNT_URI, ANALYTICS_URI, BIO_SERVICE_URI, BIO_URI, BO_ADMIN_URI, CHEMICAL_URI, CORE_BASIC_SERVICE_URI, CORE_SEARCH_SERVICE_URI, DISCOVERY_URI, EUREKA_URI, HOME_SERVICE_URI, HOME_URI, LAB_SERVICE_URI, MARKETPLACE_SERVICE_URI, OPENAPI_URI, SYNAPSE_URI, WORKSPACE_SERVICE_URI, WORKSPACE_URI, analysisApiUrlPrefix, coreBasicApiUrlPrefix, coreSearchApiUrlPrefix, emailAlertApiUrlPrefix, labServiceApiUrlPrefix, lifeScienceApiUrlPrefix, marketplaceApiUrlPrefix, passportApiUrlPrefix, workspaceApiUrlPrefix, LAB_PATENT_WORD_CLOUD_ANCHOR, LAB_WORKSPACE_LITE_TABLE_ANCHOR, coreAnalysisApiUrlPrefix, workspaceForBioApiUrlPrefix, } from '@cores/constants/envConfig';
let EnvConfigImpl = class EnvConfigImpl {
    get DEPLOY_ENV() {
        return DEPLOY_ENV;
    }
    get CLIENT_ID() {
        return CLIENT_ID;
    }
    get CLIENT_NAME() {
        return CLIENT_NAME;
    }
    get NODE_ENV() {
        return NODE_ENV;
    }
    get PACKAGE_VERSION() {
        return PACKAGE_VERSION;
    }
    get PASSPORT_URI() {
        return PASSPORT_URI;
    }
    get BO_ADMIN_URI() {
        return BO_ADMIN_URI;
    }
    get WORKSPACE_URI() {
        return WORKSPACE_URI;
    }
    get CHEMICAL_URI() {
        return CHEMICAL_URI;
    }
    get BIO_URI() {
        return BIO_URI;
    }
    get DISCOVERY_URI() {
        return DISCOVERY_URI;
    }
    get ANALYTICS_URI() {
        return ANALYTICS_URI;
    }
    get HOME_URI() {
        return HOME_URI;
    }
    get ACCOUNT_URI() {
        return ACCOUNT_URI;
    }
    get OPENAPI_URI() {
        return OPENAPI_URI;
    }
    get EUREKA_URI() {
        return EUREKA_URI;
    }
    get SYNAPSE_URI() {
        return SYNAPSE_URI;
    }
    get WORKSPACE_SERVICE_URI() {
        return WORKSPACE_SERVICE_URI;
    }
    get MARKETPLACE_SERVICE_URI() {
        return MARKETPLACE_SERVICE_URI;
    }
    get ACCOUNT_SERVICE_URI() {
        return ACCOUNT_SERVICE_URI;
    }
    get CORE_BASIC_SERVICE_URI() {
        return CORE_BASIC_SERVICE_URI;
    }
    get CORE_SEARCH_SERVICE_URI() {
        return CORE_SEARCH_SERVICE_URI;
    }
    get HOME_SERVICE_URI() {
        return HOME_SERVICE_URI;
    }
    get LAB_SERVICE_URI() {
        return LAB_SERVICE_URI;
    }
    get BIO_SERVICE_URI() {
        return BIO_SERVICE_URI;
    }
    get WSPLUGIN_ENTRY_BIO() {
        return WSPLUGIN_ENTRY_BIO;
    }
    get WSPLUGIN_ENTRY_SYNAPSE() {
        return WSPLUGIN_ENTRY_SYNAPSE;
    }
    get OFFICIAL_URL() {
        return OFFICIAL_URL;
    }
    get workspaceApiUrlPrefix() {
        return workspaceApiUrlPrefix;
    }
    get workspaceForBioApiUrlPrefix() {
        return workspaceForBioApiUrlPrefix;
    }
    get analysisApiUrlPrefix() {
        return analysisApiUrlPrefix;
    }
    get marketplaceApiUrlPrefix() {
        return marketplaceApiUrlPrefix;
    }
    get coreAnalysisApiUrlPrefix() {
        return coreAnalysisApiUrlPrefix;
    }
    get coreBasicApiUrlPrefix() {
        return coreBasicApiUrlPrefix;
    }
    get coreSearchApiUrlPrefix() {
        return coreSearchApiUrlPrefix;
    }
    get emailAlertApiUrlPrefix() {
        return emailAlertApiUrlPrefix;
    }
    get labServiceApiUrlPrefix() {
        return labServiceApiUrlPrefix;
    }
    get lifeScienceApiUrlPrefix() {
        return lifeScienceApiUrlPrefix;
    }
    get passportApiUrlPrefix() {
        return passportApiUrlPrefix;
    }
    get STATIC_COMMON_URL() {
        return STATIC_COMMON_URL;
    }
    get LAB_PATENT_COLOR_ANCHOR() {
        return LAB_PATENT_COLOR_ANCHOR;
    }
    get LAB_PATENT_WORD_CLOUD_ANCHOR() {
        return LAB_PATENT_WORD_CLOUD_ANCHOR;
    }
    get LAB_WORKSPACE_LITE_TABLE_ANCHOR() {
        return LAB_WORKSPACE_LITE_TABLE_ANCHOR;
    }
    get LAB_DEEP_VIEW_ANCHOR() {
        return LAB_DEEP_VIEW_ANCHOR;
    }
    get LAB_HI_RES_IMAGE_ANCHOR() {
        return LAB_HI_RES_IMAGE_ANCHOR;
    }
};
EnvConfigImpl = __decorate([
    injectable()
], EnvConfigImpl);
export { EnvConfigImpl };
